export {
  NicknameGeneratorModule,
  routenicknamegenerator,
  øNicknameGeneratorModule,
} from './nickname-generator.module';
export { StarterService } from './starter.service';
export { CoreServiceModule } from './core/core-service.module';
// export { ApiService } from './core/services/api.service';
export { NoticeComponent } from './core/shared/notice/notice.component';
